module.exports = __webpack_public_path__ + "static/media/Natu_gaussian2.c45bb1f8.png";